module.exports = __webpack_public_path__ + "img/logo_bob_grey.6e1450ae.png";